export default __webpack_public_path__ + "static/media/Order.e6488f13.jpg";